global.getTilePos = (obj) => {
  return {
    tx: Math.floor(obj.x / GRID),
    ty: Math.floor(obj.y / GRID)
  }
}

global.randomBetween = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

global.pickRandom = (...arr) => {
  const i = randomBetween(0, arr.length - 1)
  return arr[i]
}

global.getAtDir = (x, y, dir) => {
  switch (dir) {
    case LEFT:
      x -= GRID
      break
    case RIGHT:
      x += GRID
      break
    case UP:
      y -= GRID
      break
    case DOWN:
      y += GRID
      break
    default:
  }
  return [x, y]
}

global.toGrid = n => Math.floor(n / GRID)